var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"container p-0"},[_c('div',{staticClass:"col-12"},[_c('div',{attrs:{"id":"canvas-container"}})])])])}]

export { render, staticRenderFns }